module.exports = __webpack_public_path__ + "static/media/notice-arrow.70978eb5.svg";